<template>
  <div :class="['flex flex-col lg:flex-row items-center gap-12', { 'lg:flex-row-reverse': imagePosition === 'right' }]">
    <!-- Content -->
    <div class="flex-1">
      <h3 class="text-2xl font-bold text-ink mb-4">{{ title }}</h3>
      <p class="text-muted text-lg leading-relaxed">{{ description }}</p>
    </div>
    
    <!-- Image -->
    <div class="flex-1">
      <SmartScreenshot :image-src="imageSrc" :label="title" />
    </div>
  </div>
</template>

<script setup lang="ts">
import SmartScreenshot from './SmartScreenshot.vue'

interface Props {
  title: string
  description: string
  imageSrc: string
  imagePosition?: 'left' | 'right'
}

withDefaults(defineProps<Props>(), {
  imagePosition: 'left'
})
</script>